export const SessionStatus = {
    initalize: 'initalize',
    clearSession: 'clearSession',
    clearMember: 'clearMember',
}